// extracted by mini-css-extract-plugin
export default {"custom_logout_toast":"ProtectedRoute_custom_logout_toast__VGmZ2"};